import { useState } from 'react';
import { toast } from 'react-toastify';
import Axios from '../utils/axiosInstance';

const useNewsletter = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const subscribe = async (email) => {
    setLoading(true);
    setError(null);
    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}blog/subscribe_newsletter/`;
      const response = await Axios.post(apiUrl, {email});
      if (response.status === 200 || response.status === 201) {
        toast.success("Subscribed to Newsletter Successfully!");
        return {success:true};
      } else {
        throw new Error(response.data.message || "Subscription failed");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "An error occurred.");
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { subscribe, loading, error };
};

export default useNewsletter;
